var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{class:['v-view-primary',
  _vm.$store.getters.getAcademyData.persona === undefined || _vm.$store.getters.getAcademyDaysLeft !== null
    ? 'v-view-primary-upgrade' : '']},[_c('OrganismTheHeader'),_c('OrganismHomeLanding')],1)}
var staticRenderFns = []

export { render, staticRenderFns }